var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2229_24673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.27539 7C1.27539 3.13401 4.4094 0 8.27539 0H42.2754C46.1414 0 49.2754 3.13401 49.2754 7V41C49.2754 44.866 46.1414 48 42.2754 48H8.27539C4.4094 48 1.27539 44.866 1.27539 41V7Z",
    fill: "#F7D4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2754 33V30H24.2754V20H22.2754V23H15.2754V15H22.2754V18H28.2754V15H35.2754V23H28.2754V20H26.2754V28H28.2754V25H35.2754V33H28.2754Z",
    fill: "#D32778"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2229_24673",
    x: 0.275391,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2229_24673"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2229_24673",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeIcon);
export default __webpack_public_path__ + "static/media/tree-icon.7591396cde45f295bbbf5e7b855d6f5a.svg";
export { ForwardRef as ReactComponent };